import { useCallback, useRef, useState } from 'react'
import { useEventListener } from 'usehooks-ts'

import useDidMount from '@divvy-web/hooks.usedidmount'

export const idleDuration = 5 * 60 * 1000

export const useAuthIdleness = () => {
  const timeoutRef = useRef<number | null>(null)
  useDidMount(() => {
    timeoutRef.current = window.setTimeout(() => {
      setIsIdle(true)
    }, idleDuration)
  })
  const documentRef = useRef<Document>(document)
  const [isIdle, setIsIdle] = useState(false)

  const handleEvent = useCallback(() => {
    setIsIdle(false)
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    timeoutRef.current = window.setTimeout(() => {
      setIsIdle(true)
    }, idleDuration)
  }, [])

  useEventListener('mousemove', handleEvent)
  useEventListener('mousedown', handleEvent)
  useEventListener('resize', handleEvent)
  useEventListener('keydown', handleEvent)
  useEventListener('touchstart', handleEvent)
  useEventListener('wheel', handleEvent)
  useEventListener('visibilitychange', handleEvent, documentRef)

  return { isIdle }
}
